import Tabs from '@frontend/Components/Tabs';
import { useNavigate } from 'react-router-dom';

interface FinancialDetailsTopBarProps {
  setActivePage?: (page: string) => void;
  activePage?: string;
}

const FinancialDetailsTopBar: React.FC<FinancialDetailsTopBarProps> = ({
  setActivePage,
  activePage = 'dashboard',
}) => {
  const navigate = useNavigate();

  const switchToSection = (sectionName: string) => {
    if (setActivePage) {
      setActivePage(sectionName);
    } else {
      const routeMap: Record<string, string> = {
        dashboard: '/financials',
        invoice: '/financials/invoice',
        transactions: '/financials/transactions',
        billing: '/financials/billing',
        expenses: '/financials/expenses',
      };
      navigate(routeMap[sectionName] ?? '/financials');
    }
  };

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', onClick: () => switchToSection('dashboard') },
    { id: 'invoice', label: 'Invoice', onClick: () => switchToSection('invoice') },
    { id: 'transactions', label: 'Transactions', onClick: () => switchToSection('transactions') },
    { id: 'billing', label: 'Billing', onClick: () => switchToSection('billing') },
    { id: 'expenses', label: 'Expenses', onClick: () => switchToSection('expenses') },
  ];

  const handleTabChange = (tabId: string) => {
    const match = tabs.find((t) => t.id === tabId);
    if (match) {
      match.onClick();
    }
  };

  return (
    <div className="financial-tabs">
      <Tabs
        tabs={tabs.map(({ id, label }) => ({ id, label }))}
        activeTabId={activePage}
        onTabChange={handleTabChange}
        variant="underline"
      />
    </div>
  );
};

export default FinancialDetailsTopBar;
